@if (component) {
<href class="overflow-hidden w-12"
      [ngClass]="component.ratio || 'ratio-2-1'"
      [link]="component.link || ''">
    <shell></shell>
    <img [fill]="true"
         [ratio]="component.ratio || 'ratio-2-1'"
         [dfImage]="component.image || ''">
</href>
}
